import { makeStyles } from '@material-ui/core/styles';

export const useDetailStyles = makeStyles(() => ({
    authenticationTypeSelect: {
        width: 250,
    },
}));
